import React, { useEffect, useRef, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { useHistory } from "react-router";

import Select from "@material-ui/core/Select";
import SideNav from "../Layout/SideNav";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import alertify from "alertifyjs";
import $ from "jquery";
import axios from "axios";
import APIModel from "../../Models/APIModel";

function Payment() {
  const history = useHistory();
  const myRef = useRef(null)

  // states
  const [selectedCard, setSelectedCard] = useState(null);
  let token = localStorage.getItem("Token");
  let user_id = localStorage.getItem("user_id");
  const [host, setHost] = useState(APIModel.HOST);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [card, setCard] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [type, setType] = useState("");
  const [csv, setCsv] = useState("");
  const [promocode, setPromocode] = useState("");

  function handleChange(e) {
    setType(e.target.value);
  }

  function Subcribe() {
    let fname = $("#fname").val();
    setFname(fname);
    
    let lname = $("#lname").val();
    setLname(lname);
    let card = $("#card").val();
    setCard(card);
    let year = $("#year").val();
    setYear(year);
    let month = $("#month").val();
    setMonth(month);
    let csv = $("#csv").val();
    setCsv(csv);
    let promocode = $("#promocode").val();
    setPromocode(promocode);

    let params = {
      user_id: user_id,
      fname: fname,
      lname: lname,
      card: card,
      year: year.replace(' ', ''),
      month: month,
      type: type,
      cvv: csv,
      promocode:promocode
    };

    if (fname === "" || fname === undefined) {
      alertify.error("Please enter first name");
      return false;
    }
    if (lname === "" || lname === undefined) {
      alertify.error("Please enter last name");
      return false;
    }
    if (card === "" || card === undefined) {
      alertify.error("Please enter card no");
      return false;
    }
    if (year === "" || year === undefined) {
      alertify.error("Please enter expiry year");
      return false;
    }
    if (month === "" || month === undefined) {
      alertify.error("Please enter expiry month");
      return false;
    }

    if (type === "" || type === undefined) {
      alertify.error("Please select subcription type");
      return false;
    }


    if (csv === "" || csv === undefined) {
      alertify.error("Please enter csv number");
      return false;
    }

    return axios
      .post(host + "subscribe", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        if (response.data.status === false) {
          alertify.error(response.data.message);
        } else {
          alertify.success(response.data.message);
          localStorage.clear("Token");
          history.push("/");
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  function logout() {
    localStorage.clear("token");
    history.push("/");
  }
  function homePage() {
    window.location.replace('https://securelienrelease.com/')
  }

  const executeScroll = () => myRef.current.scrollIntoView()

  if (token) {
    return (
      <div className="wrapper">

        <div className="main-panel float-none w-100">
          <div className="contentt">
            <div className="container-fluid">
              <div className="row mt-3">


              </div>
              <div className="row mt-4">
                <div className="col-12 col-md-6">
                  <button className="btn btn-primary" onClick={() => logout()}>LOGOUT</button>
                  <button className="btn btn-primary" onClick={() => homePage()}>BACK TO HOME</button>
                  <div className="row ">
                    <div className="col-12">
                      <div onClick={executeScroll}>
                        <div className={`card bg-primary ${selectedCard === 'monthly' ? 'selectedBox' : ''}`}
        onClick={() => setSelectedCard('monthly')}>
                          <div className="card-body d-flex justify-content-between align-items-center py-5">
                            <div>
                              <h2 className="font-weight-bold">Monthly Package</h2>
                              <h3 className="font-weight-bold">$39.99</h3>
                            </div>
                            <div className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon icon-tabler icon-tabler-coin"
                                width="90"
                                height="90"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="#ffffff"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <circle cx="12" cy="12" r="9" />
                                <path d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
                                <path d="M12 6v2m0 8v2" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className={`card bg-primary ${selectedCard === 'yearly' ? 'selectedBox' : ''}`}
        onClick={() => setSelectedCard('yearly')}>
                        <div className="card-body d-flex justify-content-between align-items-center py-5">
                          <div>
                            <h2 className="font-weight-bold">Yearly Package</h2>
                            <h3 className="font-weight-bold">$407.90</h3>
                          </div>
                          <div className="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon icon-tabler icon-tabler-coin"
                              width="90"
                              height="90"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="#ffffff"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <circle cx="12" cy="12" r="9" />
                              <path d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
                              <path d="M12 6v2m0 8v2" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div id="sub-form" ref={myRef}>
                    <div className="card" >
                      <div className="card-header border-bottom-2">
                        <h3 className="card-title">Account Details</h3>
                      </div>
                      <div className="card-body">
                        <form action="">
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-12">
                                <div className="form-group">
                                  <label htmlFor="">First Name</label>
                                  <input type="text"
                                    className="form-control"
                                    name="fname"
                                    id="fname"
                                    value={fname}
                                    onChange={(e) => setFname(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-12">
                                <div className="form-group">
                                  <label htmlFor="">Last Name</label>
                                  <input type="text"
                                    className="form-control"
                                    name="lname"
                                    id="lname"
                                    value={lname}
                                    onChange={(e) => setLname(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row mb-2">
                              <div className="col-12">
                                <FormControl className="col-md-12">
                                  <InputLabel id="demo-simple-select-helper-label">
                                    Select Your Subcription Package
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="type"
                                    name="type"
                                    value={type}
                                    onChange={handleChange}
                                    label="type"
                                  >
                                    <MenuItem value="">
                                      <em>Choose your option</em>
                                    </MenuItem>
                                    <MenuItem value={"Monthly"}>Monthly (39.99$)</MenuItem>
                                    <MenuItem value={"Yearly"}>Yearly (407.90$)</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 mt-2">
                                <div className="form-group">
                                  <label className="">
                                    Card No
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="card"
                                    name="card"
                                    value={card}
                                    onChange={(e) => {
                                      const inputCard = e.target.value.replace(/\s/g, ''); // Remove existing spaces
                                      const formattedCard = inputCard.slice(0, 16).replace(/(\d{4})(?=\d)/g, '$1 '); // Add space after every 4 digits
                                      setCard(formattedCard);
                                    }}
                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-6 mt-2">
                                <div className="form-group">
                                  <label className="bmd-label-floating">
                                    Expiry Month
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control input-box"
                                    id="month"
                                    name="month"
                                    value={month}
                                    onChange={(e) => {
                                      const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                      let formattedInput = input;

                                      if (input.length > 2) {

                                        formattedInput = `${month}`;
                                      }

                                      setMonth(formattedInput);
                                    }}

                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-6 mt-2">
                                <div className="form-group">
                                  <label className="bmd-label-floating">
                                    Expiry Year
                                  </label>
                                  <input
                                    type="text"
                                    pattern="[0-9]*"
                                    className="form-control input-box"
                                    id="year"
                                    name="year"
                                    value={year}
                                    onChange={(e) => {
                                      const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                      let formattedInput = input;

                                      if (input.length > 4) {

                                        formattedInput = `${year}`;
                                      }

                                      setYear(formattedInput);
                                    }}

                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-6 mt-2">
                                <div className="form-group">
                                  <label className="bmd-label-floating">
                                    CVV Number
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control input-box"
                                    id="csv"
                                    name="csv"
                                    value={csv}
                                    onChange={(e) => {
                                      const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                      let formattedInput = input;

                                      if (input.length > 4) {

                                        formattedInput = `${csv}`;
                                      }

                                      setCsv(formattedInput);
                                    }}

                                    required
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-6 mt-2">
                            <div className="row">
                              <div className="col-12">
                                <div className="form-group">
                                  <label htmlFor="">Promo Code </label>
                                  <input type="text"
                                    className="form-control"
                                    name="promocode"
                                    id="promocode"
                                    value={promocode}
                                    onChange={(e) => setPromocode(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                            onClick={() => {
                              Subcribe();
                            }}
                          >
                            Subcribe Now
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default Payment;
